import { render, staticRenderFns } from "./task-part-list.vue?vue&type=template&id=a364d0c6&scoped=true"
import script from "./task-part-list.vue?vue&type=script&lang=js"
export * from "./task-part-list.vue?vue&type=script&lang=js"
import style0 from "./task-part-list.vue?vue&type=style&index=0&id=a364d0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a364d0c6",
  null
  
)

export default component.exports